import React, {Component} from 'react';

import dsgClasses from './dsg_classes.json';

class GeographicFeatureClasses extends Component {

    componentDidMount () {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div className="component-wrapper">
                <div className="flex-row">
                    <div className="flex-column">
                        <div className='list-table-title'>
                            <h1>Geographic Feature Classes</h1>
                        </div>
                        <div className='list-table'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>DSG Class</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {dsgClasses.map((dsgClass) =>
                                    <tr key={dsgClass.code}>
                                        <td>{dsgClass.code}</td>
                                        <td>{dsgClass.name}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default GeographicFeatureClasses;